import { Route } from "react-router-dom";
import NewsListIndex from "./Pages/NewsList/NewsListIndex";
import NewsDetailsIndex from "./Pages/NewsDetails/NewsDetailsIndex";




export const newsRouteList = [
  <Route key={"newsRouteList"}>
     <Route path="/haber/list" element={<NewsListIndex />}  />
     <Route path="/haber/detay/:newsId" element={<NewsDetailsIndex/>}  />
  </Route>,
];
